/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cli_3_TitleInputs */

const en_mk_cli_3_title = /** @type {(inputs: Mk_Cli_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An MCP server for your agent`)
};

const id_mk_cli_3_title = /** @type {(inputs: Mk_Cli_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Server MCP untuk agent`)
};

/**
* | output |
* | --- |
* | "An MCP server for your agent" |
*
* @param {Mk_Cli_3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cli_3_title = /** @type {((inputs?: Mk_Cli_3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cli_3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cli_3_title(inputs)
	return en_mk_cli_3_title(inputs)
});